import {IntlShape} from "react-intl";
import {CartTimelineOrder} from "@/data/entities/cartTimeline";
import {CartInTimeline} from "@widgets/reports/cartTimeline/CartTimelineUtils";
import {formatMoney} from "@/utils/MoneyUtils";

/**
 * How the order is paid, e.g. `Online, iDEAL`, `Bij afhalen` or `Kassa`.
 */
export const paymentLabel = (item: CartInTimeline, order: CartTimelineOrder, intl: IntlShape): string => {
    if (item.kind === "pos")
        return intl.formatMessage({id: "cartTimeline.payment.pos"});
    if (order.paymentMethod === "ONLINE")
        return intl.formatMessage({id: "cartTimeline.payment.online"});
    return intl.formatMessage({
        id: item.cart.isDelivery ? "cartTimeline.payment.onDelivery" : "cartTimeline.payment.onTakeaway",
    });
};

/**
 * Value and payment of the order, e.g. `€ 29,50 · Online, iDEAL`. A dash
 * without an order.
 */
export const orderSummary = (item: CartInTimeline): string | null =>
    !item.cart.order
        ? null
        : `${formatMoney(item.cart.order.totalToPay)}`;